import React from 'react';
import { useCompanyStore } from 'stores';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
//styles
import './home.scss'

const BannerPromotional = () => {
  const {home_image, home_url} = useCompanyStore();

  return (
    <Col xs={12} sm={12} md={12} className="container-banner-promotional">
      <Link to={home_url} target="_blank">
        <img src={home_image} alt="Promotional Banner" className="w-100"/>
      </Link>
    </Col>
  );
};

export default BannerPromotional;